if (!customElements.get('impulse-collection-tabs')) {
  class ImpulseCollectionTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tablist || !this.tabs.length || !this.panels.length) {
        return;
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.tablist.addEventListener('click', this.handleClick);
      this.tablist.addEventListener('keydown', this.handleKeydown);
      this.addEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );

      const initialTab =
        this.tabs.find((tab) => tab.classList.contains('is-active')) ||
        this.tabs[0];

      this.activateTab(initialTab, false);
      this.initialized = true;
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.tablist.removeEventListener('click', this.handleClick);
      this.tablist.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );

      this.initialized = false;
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');

      if (!tab || !this.contains(tab)) return;

      event.preventDefault();
      this.activateTab(tab, false);
    }

    handleKeydown(event) {
      const currentTab = event.target.closest('[role="tab"]');

      if (!currentTab) return;

      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex =
          (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }

    handleBlockSelect(event) {
      const blockId =
        event.detail && event.detail.blockId
          ? event.detail.blockId
          : event.target.dataset.blockId;

      if (!blockId) return;

      const selectedTab = this.tabs.find(
        (tab) => tab.dataset.blockId === blockId
      );

      if (selectedTab) {
        this.activateTab(selectedTab, false);
      }
    }

    activateTab(selectedTab, moveFocus) {
      const panelId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === selectedTab;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === panelId;

        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      if (moveFocus) {
        selectedTab.focus();
      }

      if (
        window.AOS &&
        typeof window.AOS.refreshHard === 'function'
      ) {
        requestAnimationFrame(() => {
          window.AOS.refreshHard();
        });
      }
    }
  }

  customElements.define(
    'impulse-collection-tabs',
    ImpulseCollectionTabs
  );
}